import '@/styles/index.css';
import AppProvider from './app.provider';
import AppRoute from './app.route';

export default function App() {
  return (
    <AppProvider>
      <AppRoute />
    </AppProvider>
  );
}
